/**
 * Тур по странице RegTech (SENT / e-TOLL).
 * Знакомит пользователя с функциями мониторинга и управления передачей данных в государственные системы.
 * ВАЖНО: Тур работает только на больших экранах (>= 769px).
 */
export default {
  id: 'regtech-page',
  name: 'help.tours.regtech.name',
  description: 'help.tours.regtech.description',

  options: {
    showProgress: true,
    allowClose: true,
    stagePadding: 12,
    stageRadius: 8,
  },

  steps: [
    // Шаг 1: Приветствие
    {
      element: '.page-title',
      titleKey: 'help.tours.regtech.welcome.title',
      descriptionKey: 'help.tours.regtech.welcome.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 2: Кнопка списка RMPD
    {
      element: '.btn--rmpd',
      titleKey: 'help.tours.regtech.rmpdList.title',
      descriptionKey: 'help.tours.regtech.rmpdList.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 3: Кнопка добавления устройств
    {
      element: '.btn--add',
      titleKey: 'help.tours.regtech.addDevices.title',
      descriptionKey: 'help.tours.regtech.addDevices.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 4: Статистика и фильтр по сервисам
    {
      element: '.stats-row',
      titleKey: 'help.tours.regtech.stats.title',
      descriptionKey: 'help.tours.regtech.stats.description',
      side: 'bottom',
      align: 'start',
    },
    // Шаг 5: Фильтр по группам
    {
      element: '.group-filter',
      titleKey: 'help.tours.regtech.groupFilter.title',
      descriptionKey: 'help.tours.regtech.groupFilter.description',
      side: 'bottom',
      align: 'center',
    },
    // Шаг 6: Поиск
    {
      element: '.search-bar',
      titleKey: 'help.tours.regtech.search.title',
      descriptionKey: 'help.tours.regtech.search.description',
      side: 'bottom',
      align: 'end',
    },
    // Шаг 7: Список устройств
    {
      element: '.regtech-grid',
      titleKey: 'help.tours.regtech.devicesList.title',
      descriptionKey: 'help.tours.regtech.devicesList.description',
      side: 'top',
      align: 'center',
    },
    // Шаг 8: Карточка устройства
    {
      element: '.regtech-card',
      titleKey: 'help.tours.regtech.deviceCard.title',
      descriptionKey: 'help.tours.regtech.deviceCard.description',
      side: 'left',
      align: 'center',
    },
    // Шаг 9: Блок сервиса (SENT/e-TOLL)
    {
      element: '.service-block',
      titleKey: 'help.tours.regtech.serviceBlock.title',
      descriptionKey: 'help.tours.regtech.serviceBlock.description',
      side: 'left',
      align: 'start',
    },
    // Шаг 10: Переключатель и кнопки (иконки)
    {
      element: '.service-row',
      titleKey: 'help.tours.regtech.serviceRow.title',
      descriptionKey: 'help.tours.regtech.serviceRow.description',
      side: 'left',
      align: 'center',
    },
  ],
}
